<template>
  <base-loader :loading="loadingData">
    <div class="view-container">
      <maintenance-transactions-table :header="tableHeader" :data="transactions"/>
    </div>
  </base-loader>
</template>

<script>

  import MaintenanceTransactionsTable from "../../components/maintenancePayments/MaintenanceTransactionsTable";
  import Payments from '../../services/MaintenancePayments';

  export default {
    name: 'MaintenancePaymentTransactions',
    components: {
      MaintenanceTransactionsTable,
    },
    data () {
      return {
        transactions: [],
        loadingData: false,
        paymentId: null,
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('maintenancePayments.table.paid_at'),
          this.$t('maintenancePayments.table.amount'),
        ])
      },
    },
    methods: {
      getTransactions () {
        this.loadingData = true;
        Payments.getTransactions(this.paymentId).then(transactions => {
          const total = transactions.reduce((a, b) => a + (b.amount || 0), 0);
          transactions.push({
            class: 'hrsys-total',
            name: this.$t('maintenancePayments.table.total'),
            currency: transactions[0].currency,
            amount: total
          });
          this.transactions = transactions;
        }).finally(() => {
          this.loadingData = false;
        })
      }
    },
    mounted () {
      this.paymentId = parseInt(this.$route.params.id);
      this.getTransactions();
    }
  }
</script>

<style scoped>

</style>
